import React from 'react';

type BannerItemProps = {
  src: string;
  srcSet: {
    webp: string;
    png: string;
    fullWebp: string;
  };
  alt: string;
  href: string;
}

const BannerItem: React.FC<BannerItemProps> = ({ src, srcSet, alt, href }) => {
  return (
    <React.Fragment>
      <li className="correct-box__banner-list-item">
        <a href={href} target="_blank" rel="noopener noreferrer">
          <picture>
            <source srcSet={srcSet.webp} media="(max-width:834px)" type="image/webp" />
            <source srcSet={srcSet.png} media="(max-width:834px)" />
            <source srcSet={srcSet.fullWebp} type="image/webp" />
            <img src={src} alt={alt} />
          </picture>
        </a>
      </li>
    </React.Fragment>
  )
}

export default BannerItem;